/** Characters that are invalid in file names on Windows/macOS/Linux, plus control chars. */
export const INVALID_FILENAME_CHARS_RE = /[<>:"/\\|?*\u0000-\u001F]/g;

/**
 * Replaces invalid file-name characters with spaces, trims and drops trailing dots
 * (Windows strips them, which could collide with a sibling); falls back when nothing is left.
 */
export function sanitizeFilenameBase(
  input: string | null | undefined,
  fallback = 'export'
): string {
  const cleaned = (input ?? '')
    .replace(INVALID_FILENAME_CHARS_RE, ' ')
    .replace(/[\s.]+$/, '')
    .trim();
  return cleaned || fallback;
}

/**
 * Appends " (2)", " (3)", … to repeated names so they can coexist in one folder.
 * Names are compared case-insensitively (Windows and macOS file systems are).
 */
export function dedupeFilenames(names: string[]): string[] {
  const used = new Set<string>();

  return names.map((name) => {
    let candidate = name;

    for (let suffix = 2; used.has(candidate.toLowerCase()); suffix++) {
      candidate = `${name} (${suffix})`;
    }

    used.add(candidate.toLowerCase());
    return candidate;
  });
}
